// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__l4uRl","overflowing":"ReadFullNote_overflowing__-L-u9"};